import React, { Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { ProtectedRoute, PublicRoute } from './pages/ProtectedRoute';
import WhatsAppButton from './components/WhatsAppButton';

const LoginPage = React.lazy(() => import('./pages/LoginPage'));
const PendingPage = React.lazy(() => import('./pages/PendingPage'));
const StudentDashboard = React.lazy(() => import('./pages/StudentDashboard'));
const AdminPanel = React.lazy(() => import('./pages/AdminPanel'));
const InstructorPanel = React.lazy(() => import('./pages/InstructorPanel'));

const LoadingFallback = () => (
  <div
    style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'var(--bg-body)',
    }}
  >
    <div
      style={{
        width: 40,
        height: 40,
        border: '3px solid #7c3aed33',
        borderTop: '3px solid #7c3aed',
        borderRadius: '50%',
        animation: 'spin .8s linear infinite',
      }}
    />
    <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
  </div>
);

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/"
        element={
          <PublicRoute>
            <LoginPage />
          </PublicRoute>
        }
      />
      <Route
        path="/pending"
        element={
          <ProtectedRoute allowedRoles={['student']}>
            <PendingPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute allowedRoles={['student']}>
            <StudentDashboard />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute allowedRoles={['admin']}>
            <AdminPanel />
          </ProtectedRoute>
        }
      />
      <Route
        path="/instructor"
        element={
          <ProtectedRoute allowedRoles={['instructor']}>
            <InstructorPanel />
          </ProtectedRoute>
        }
      />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <BrowserRouter>
        <AuthProvider>
          <Suspense fallback={<LoadingFallback />}>
            <AppRoutes />
            <WhatsAppButton />
          </Suspense>
        </AuthProvider>
      </BrowserRouter>
    </ErrorBoundary>
  );
}
